<template>
  <b-row class="app-section p-5">
    <b-col cols="4">
      <b-card-group deck>
        <b-card align="center">
          <template v-slot:header>
            <h3>Application Information</h3>
          </template>
          <b-list-group class="app-info-list">
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <strong>Version:</strong>
              <b-badge variant="primary" pill>{{appVersion}}</b-badge>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <strong>Development stage:</strong>
              <b-badge variant="primary" pill>beta-release</b-badge>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <strong>Maintained by:</strong>
              <b-badge variant="primary" pill>University of Washington</b-badge>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-card-group>
    </b-col>
    <b-col cols="8">
      <b-card>
        <template v-slot:header>
          <div align="center">
            <h3>Changelog</h3>
          </div>
        </template>
        <b-card-body v-if="changeLogs.length == 0">
          <h4>No change logs found.</h4>
          <b-alert show variant="danger" v-if="error">{{error}}</b-alert>
        </b-card-body>
        <div v-if="!error && changeLogs.length > 0">
          <b-card no-body v-for="(post, idx) in changeLogs" :key="post.id">
            <b-card-header header-tag="header" role="tab">
              <b-button block href="#" v-b-toggle="`accordion-${post.id}`" variant="light">
                <h4 :id="`list-${post.meta.portal_version[0]}`" @click="getListID">
                  Release {{post.meta.portal_version[0]}}
                  <i class="fas fa-angle-down"></i>
                </h4>
              </b-button>
            </b-card-header>
            <b-collapse :id="`accordion-${post.id}`" :visible="idx == 0"
            accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <div align="center">
                  <h5 class="changelog-title">{{post.title.rendered}}</h5>
                  <small>{{formatDate(post.date_gmt)}}</small>
                </div>
                <div class="changelog-list" v-html="post.content.rendered"></div>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
  data() {
    return {
      appVersion: process.env.APPVERSION,
      changeLogs: [],
      error: null,
    };
  },
  mounted() {
    this.retriveLogs();
  },
  methods: {
    formatDate(date) {
      let localTime = moment.utc(date).toDate();
      // dddd indicates the date name
      // hh uses 12 hour time, HH uses 24 hour time
      // a indicates post or ante meridiem (AM or PM)
      // Currently using the American example: Tuesday, November 09, 2021 1:00 pm
      // International example: Tuesday, 09 November 2021 13:00
      localTime = moment(localTime).format('dddd, MMMM DD, YYYY hh:mm a');
      return localTime;
    },
    updateLogs(data) {
      this.changeLogs = data;
    },
    processError(error) {
      this.error = error;
    },
    retriveLogs() {
      axios
        .get(
          'https://interactiveoceans.washington.edu/wp-json/wp/v2/posts?categories=191',
        )
        .then((response) => this.updateLogs(response.data))
        .catch((error) => this.processError(error));
    },
    /** Gets the ID of the clicked element for GA event */
    getListID(event) {
      this.$ga('event', event.target.id);
    },
  },
};
</script>

<style>
.changelog-list {
  padding: 30px;
}
.changelog-list > ul > li {
  font-size: 1rem;
}
.changelog-title {
  font-size: 1.125rem;
}
.app-info-list {
  font-size: 1.125rem;
}
</style>
